import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './ticket-counts-selector.scss'
import NumberInputWithStepper from 'src/components/common/NumberInputWithStepper/NumberInputWithStepper'

export default class TicketCountsSelector extends Component {
  _renderLabel = (countType) => {
    const { child_count_enabled } = this.props
    if (countType === 'adult') {
      if (!child_count_enabled) {
        return 'Guests'
      }
      return 'Adults'
    } else {
      return 'Children'
    }
  }

  _renderRow = () => {
    const { ticketCounts, onChangeCount, disabled } = this.props

    if (ticketCounts.length === 0) {
      window.location.reload()
      return ''
    }

    return (
      <div className={styles['row']}>
        {
          ticketCounts.map((item) => {
            return (
              <div key={item.id} className={styles['select-wrapper']}>
                <NumberInputWithStepper
                  value={item.count}
                  onChange={newValue => {
                    onChangeCount(item.id, newValue)
                  }}
                  min={item.label === 'adult' ? 1 : 0}
                  max={10}
                  label={this._renderLabel(item.label)}
                  disabled={disabled}
                  inputRowClassName={styles['number-input-row']}
                  labelClassName={styles['label']}
                  iconClassName={styles['stepper-icon']}
                  inputClassName={styles['number-input']}
                />
              </div>
            )
          })
        }
      </div>

    )
  }

  render() {
    return <div>
      {this._renderRow()}
    </div>
  }
}

TicketCountsSelector.propTypes = {
  onChangeCount: PropTypes.func,
  ticketCounts: PropTypes.array,
  disabled: PropTypes.bool,
  child_count_enabled: PropTypes.bool
}
